import React from "react";
import PropTypes from "prop-types";

import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { push, replace } from "connected-react-router";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import Icon from "@material-ui/core/Icon";
import ArrowBack from "@material-ui/icons/ArrowBack";

// core components
import Button from "components/CustomButtons/Button.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardAvatar from "components/Card/CardAvatar.jsx";
import CardFooter from "components/Card/CardFooter.jsx";

import defaultUserImage from 'assets/img/no_profile.png';

import lockScreenPageStyle from "assets/jss/material-dashboard-pro-react/views/lockScreenPageStyle.jsx";
import { store } from "../../redux/store";
import { LOGIN_SUCCESS, SET_NOTIFICATIONS, SET_OTP, OTP_REQUIRED } from "../../redux/types";
import Api from "../../api/Api.js";
import Loading from '../../components/Loading/Loading.jsx';
import AuthEndpoints from "../../api/AuthEndpoints";
import { GoogleReCaptcha, useGoogleReCaptcha, withGoogleReCaptcha } from "react-google-recaptcha-v3";

class LockedOut extends React.Component {
  constructor(props) {
    super(props);
    // we use this to make the card to appear after the page has been rendered
    this.state = {
      cardAnimaton: "cardHidden",
      password: '',
      passwordInvalid: false,
      loading: false
    };
  }
  componentDidMount() {
    // we add a hidden class to the card and after 700 ms we delete it and the transition appears
    this.timeOutFunction = setTimeout(
      function () {
        this.setState({ cardAnimaton: "" }, () => {
          if (Api.isLoggedIn() && !Api.isLocked()) {
            store.dispatch(push('/dashboard'));
          }
        });
      }.bind(this),
      700
    );

    if (this.props.id === 0) {
      //debugger;
      //throw new Error('Redirect Error Locked Out');
      store.dispatch(push('/login'));
    }
  }
  componentWillUnmount() {
    clearTimeout(this.timeOutFunction);
    this.timeOutFunction = null;
  }
  async submitLogin() {
    if (!this.state.password) {
      this.setState({ passwordInvalid: true });
      return;
    }
    this.setState({ loading: true }, async () => {
      var recaptchaTimeout;

      const recaptcha_token = await Promise.race(
        [
          this.props.googleReCaptchaProps.executeRecaptcha('lockedOut'),
          new Promise((resolve, reject) => {
            recaptchaTimeout = setTimeout(() => {
              resolve(null);
            }, 1000);
          })
        ]
      );

      if (recaptchaTimeout)
        clearTimeout(recaptchaTimeout);

      Api.post(AuthEndpoints.doesRequireOtp, { username: this.props.username, password: this.state.password, recaptcha_token }, 1, false)
        .then((response) => {

          let data;

          if (!response.data) {
            console.error("No Usable Data Received from Login Attempt");
            this.setState({ password: '', passwordInvalid: true, usernameInvalid: false, loading: false });
            return;
          } else {
            data = response.data;
          }
          
          if (data.mfa || data.sms || data.email) {
            store.dispatch({ type: SET_OTP, ...data });
            store.dispatch({ type: OTP_REQUIRED, payload: { username: this.props.username, password: this.state.password } });
            store.dispatch(push('/otp'));
          } else if (data.token) {
            Api.loggedIn(data.token, data.user.role.role1, data)
            store.dispatch({ type: LOGIN_SUCCESS, user: data.user });
            store.dispatch({ type: SET_NOTIFICATIONS, payload: data.notifications });
            store.dispatch(replace('/dashboard'));
          }
        })
        .catch((e) => {
          console.error(e);
          this.setState({ password: '', passwordInvalid: true, loading: false });
        })
    });
  }
  render() {
    const { classes } = this.props;
    return (
      <div className={classes.container}>
        <form onSubmit={(e) => e.preventDefault()}>
          <input id="username" autoComplete="username" type="hidden" name="username" value={this.props.username} />
          <Card
            profile
            className={
              classes.customCardClass + " " + classes[this.state.cardAnimaton]
            }
          >
            <Button style={{ position: 'absolute', left: 5, right: 0 }} component={Link} to="/login" justIcon round color="rose"><ArrowBack /></Button>

            <CardAvatar profile className={classes.cardAvatar}>
              <img src={this.props.image ? `/api/image/get?id=${this.props.image}` : defaultUserImage} />
            </CardAvatar>
            <CardBody profile>
              <h4 className={classes.cardTitle}>{this.props.name} {this.props.surname || ""}</h4>
              <CustomInput
                labelText={(this.state.passwordInvalid ? "Invalid Password" : "Enter Password")}
                id="password"
                formControlProps={{
                  fullWidth: true
                }}
                inputProps={{
                  type: "password",
                  onChange: (event) => {
                    this.setState({ password: event.target.value, passwordInvalid: false });
                  },
                  value: this.state.password,
                  onKeyPress: (e) => {
                    if (e.key === 'Enter') {
                      this.submitLogin();
                    }
                  },
                  autoComplete: "current-password"
                }}
              />
            </CardBody>
            <CardFooter className={classes.justifyContentCenter}>
              {
                this.state.loading ?
                  <div style={{ paddingBottom: 10 }}>
                    <Loading />
                  </div>
                  :
                  <Button color="rose" round onClick={() => this.submitLogin()}>
                    <Icon className={classes.inputAdornmentIcon}>
                      lock_open_outline
                </Icon>
                    Unlock
              </Button>
              }
            </CardFooter>
          </Card>
        </form>
      </div>
    );
  }
}

LockedOut.propTypes = {
  classes: PropTypes.object.isRequired
};

const mapStateToProps = (state) => ({ ...state.user });
export default withStyles(lockScreenPageStyle)(withGoogleReCaptcha(connect(mapStateToProps)(LockedOut)));
